<template>
	<div class="company-mail-item">
		<el-row :gutter="10" class="email-rows">
			<el-col :span="2" class="company-domain">{{ item.emailDomain }}</el-col>
			<el-col :span="4">
				<sky-select
					v-model="item.emailType"
					:disabled="isdisabled"
					class="mail-select"
					:options="options"
				></sky-select>
			</el-col>
			<!-- 手动 -->
			<el-col :span="15" v-if="item.emailType == 1">
				<el-row :gutter="20">
					<el-col :span="10">
						<el-input
							v-model="item.mailbox"
							placeholder="请输入邮箱地址"
							@input="handChanged"
						></el-input>
					</el-col>
					<el-col :span="9">
						<el-input
							type="password"
							v-model="item.password"
							placeholder="请输入邮箱密码"
							:show-password="true"
							@input="handChanged"
						></el-input>
					</el-col>
					<el-col :span="4" style="display: flex">
						<!-- 验证的图标 -->
						<!-- <el-tooltip v-if="getCheckStatus(item).id == 2"
                        class="item"
                        effect="dark"
                        content="验证通过"
                        placement="top-start">
              <el-button type="text"
                         style="margin-bottom:0"
                         circle>
                <i class="el-icon-success"></i></el-button>
            </el-tooltip>
            <el-tooltip v-if="getCheckStatus(item).id == 3"
                        class="item"
                        effect="dark"
                        content="验证失败"
                        placement="top-start">
              <el-button type="text"
                         style="margin-bottom:0"
                         size="mini"
                         circle>
                <i class="el-icon-error"></i></el-button>
            </el-tooltip> -->
						<el-button
							:size="buttonSize"
							:type="buttonType"
							:loading="checkLoading"
							@click="validEmail(item)"
							>验证邮箱</el-button
						>
						<el-button
							:size="buttonSize"
							:type="buttonType"
							:loading="resetEamilLoading"
							@click="resetEmail(item)"
							>重置邮箱</el-button
						>
					</el-col>
				</el-row>
			</el-col>
			<!-- 自动 -->
			<el-col :span="15" v-else>
				<el-row :gutter="20">
					<el-col :span="8">
						<el-select
							v-model="domainId"
							placeholder="选择渠道账号"
							filterable
							remote
							clearable
							:disabled="isdisabled"
							:remote-method="getChannelAccountList"
							@change="channelAccountChange"
						>
							<el-option
								v-for="item in channelAccountList"
								:key="item.id"
								:label="item.domainName"
								:value="item.id"
							>
								<span style="float: left">{{ item.domainName }}</span>
							</el-option>
						</el-select>
					</el-col>
					<el-col :span="12">
						<el-input placeholder="请输入邮箱名" v-model="item.email" :disabled="isdisabled">
							<template slot="append">@{{ item.emailDomain }}</template>
						</el-input>
					</el-col>
					<el-col :span="4" style="display: flex">
						<!-- 开通邮箱 -->
						<el-button
							:size="buttonSize"
							:type="buttonType"
							:loading="openingLoading"
							:disabled="isdisabled"
							@click="openingMail(item)"
							>{{ getOpeningTxt }}</el-button
						>
						<el-button
							:size="buttonSize"
							:type="buttonType"
							:loading="resetLoading"
							@click="resetPassword(item)"
							>重置密码</el-button
						>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import website from '@/backend/services/website/website.js';
export default {
	props: ['value'],
	components: {
		skySelect,
	},
	data() {
		return {
			item: {},
			domainId: this.value.domainid || '',
			channelAccountList: [],
			buttonSize: 'small',
			buttonType: 'primary',
			options: [
				{ label: '手动添加', value: 1 },
				{ label: '自动添加', value: 2 },
			],
			checkLoading: false,
			resetEamilLoading: false,
			openingLoading: false,
			resetLoading: false,
		};
	},
	watch: {
		value: {
			handler(val) {
				this.item = { ...val };
				if (val.emailType == 2 && val.flagOpen !== true) {
					this.item.flagOpen = false;
				}
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		getOpeningTxt() {
			if (this.item.emailType == 2) {
				return this.item.flagOpen ? '已开通' : '开通邮箱';
			} else {
				return '开通邮箱';
			}
		},
		isdisabled() {
			if (this.item.emailType == 2) {
				return this.item.flagOpen;
			}
			return false;
		},
	},
	filters: {
		getSliceCustomDomain(val) {
			if (!val) return '';
			return val.toString().split('.').slice(-2).join('.');
		},
	},
	mounted() {
		this.getChannelAccountList();
	},
	methods: {
		validEmail(item) {
			this.$emit('validEmail', item, col => {
				if (col) {
					this.item = col;
				}
				this.checkLoading = !this.checkLoading;
			});
		},
		resetEmail(item) {
			this.$emit('resetEmail', item, col => {
				if (col) {
					this.item = col;
				}
				this.resetEamilLoading = !this.resetEamilLoading;
			});
		},
		openingMail(item) {
			item.domainId = this.domainId;
			this.$emit('openingMail', item, col => {
				if (col) {
					this.item = col;
				}
				this.openingLoading = !this.openingLoading;
			});
		},
		resetPassword(item) {
			item.domainId = this.domainId;
			this.$emit('resetPassword', item, col => {
				if (col) {
					this.item = col;
				}
				this.resetLoading = !this.resetLoading;
			});
		},

		getCheckStatus(col) {
			let status = [
				{ id: 1, label: '验证邮箱', type: 'primary' },
				{ id: 2, label: '验证通过', type: 'success' },
				{ id: 3, label: '验证失败', type: 'warning' },
			];
			return status.find(item => item.id == col.checkStatus);
		},
		handChanged() {
			this.item.handChanged = true;
		},
		// 获取渠道账号列表
		async getChannelAccountList(val) {
			try {
				let res = await website.getDomainlist({
					domainName: val || '',
				});
				this.channelAccountList = res.data;
			} catch (e) {
				this._info('获取渠道账号列表失败');
			}
		},
		// 渠道账号变化
		channelAccountChange(id) {
			let obj = {};
			obj = this.channelAccountList.find(item => {
				return item.id === id;
			});
			if (obj) {
				this.domainId = id;
				// this.customDomain = obj.domainName;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.email-rows {
	float: left;
	margin-bottom: 20px;
}

.el-icon-success {
	color: #67c23a;
}

.el-icon-error {
	color: #f56c6c;
}

.company-domain {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
</style>
